module.exports = __webpack_public_path__ + "static/media/trombone-hadestown-2.9f660812.jpg";